import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Constants } from '../../constants/constants';
import { Repository } from '../../services/Repository';
import { TrackingService } from '../../services/TrackingService';
import { trigger, transition, style, animate } from '@angular/animations';
import { MatMenuTrigger } from '@angular/material/menu';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ModalData, PopupModalComponent } from '../popupModal/popup-modal/popup-modal.component';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(10px)' }), // Start from below
        animate('300ms ease-in', style({ opacity: 1, transform: 'translateY(0)' })) // Slide up
      ]),
      transition(':leave', [
        animate('300ms ease-out', style({ opacity: 0, transform: 'translateY(10px)' })) // Slide down
      ])
    ])
  ]
})
export class HeaderComponent implements OnInit {
  Name!: string;
  headerLabel: any = '';
  loginPage: any = 'Login';
  showLogoutpopover: boolean = false;
  isMobileView: boolean = false;
  showMobileMenu: boolean = false;
  @ViewChild(MatMenuTrigger) mobileMenuTrigger!: MatMenuTrigger;
  hideNavbarCenter: boolean = false; // Default is false (visible)
  userRole: string = '';
  hidebackbtn: any
  constructor(private location: Location, private _cookieService: CookieService, private _router: Router, private _spinner: NgxSpinnerService,
    private trackingService: TrackingService, private dialog: MatDialog) {
    this.hidderoutes()
    this.getCurrentPage()
  }
  ngOnInit(): void {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    console.log(user, 'header');

    this.userRole = user.role
    this.trackingService.username$.subscribe((username) => {
      this.Name = username || this._cookieService.get("KYCUserId") || '';
    });
    this.checkScreenSize();
    this.hidebackbtn = sessionStorage.getItem('hidebackbtn')
  }
  @HostListener('window:resize', [])
  checkScreenSize() {
    this.isMobileView = window.innerWidth < 1000; // Change breakpoint as needed
  }
  toggleMobileMenu() {
    this.showMobileMenu = !this.showMobileMenu;
  }
  openMenu(trigger: MatMenuTrigger) {
    trigger.openMenu();
  }
  showLogout() {
    this.showLogoutpopover = !this.showLogoutpopover
  }

  @HostListener('document:click', ['$event'])
  handleClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const mobileOptions = document.querySelector('.mobile-options');
    const dropdown = document.querySelector('.show-notification');
    // Check if the click is outside the mobile options and the dropdown
    if (mobileOptions && !mobileOptions.contains(target) && dropdown && !dropdown.contains(target)) {
      this.showLogoutpopover = false; // Close the dropdown
    }
  }
  logout() {
    this.openModal()

  }

  LogOutClear() {
    localStorage.clear();
    sessionStorage.clear();
    this._cookieService.deleteAll("/", "");
    this._router.navigateByUrl(this.loginPage);
  }
  showHeader: boolean = true;
  pageName: any = ''
  showloginheader: boolean = true;
  showKycDashboard: boolean = true;
  showPobDashboard: boolean = true;
  showHome: boolean = false;
  showlogout: boolean = true;
  Page: any
  hidderoutes() {
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    this._router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {

        // List of routes where the header should be hidden
        const hiddenRoutes = ['/homepage/PobDashboard', '/homepage', '/Login', '/UserKycDashboard'];
        if (event.url == '/Login' || event.url == '/') {
          this.showloginheader = true
        } else {
          this.showloginheader = false
        }

        // Hide navbar-center when on homepage
        this.hideNavbarCenter = event.url === '/homepage';

        // Extract the last segment of the URL
        const cleanUrl = event.url.split('?')[0];
        const urlSegments = cleanUrl.split('/');
        const lastSegment = urlSegments[urlSegments.length - 1];
        this.Page = lastSegment
        // Mapping route segments to user-friendly page titles
        const pageTitleMap: { [key: string]: string } = {
          'hcpselection': 'HCP Selection',
          'productlist': 'Product Catalogue',
          'hcpdetails': 'HCP Details',
          'cart': 'Cart',
          'homepage': 'Home',
          'pobhome': 'POB Dashboard',
          'cartdetails': 'Cart Details',
          'repkycdashboard': 'KYC Dashboard',
          'userkycdashboard': 'KYC Dashboard'
        };
        // Set the page name based on the mapping, or use the last segment with formatting
        this.pageName = pageTitleMap[lastSegment.toLowerCase()] || this.capitalizeFirstLetter(lastSegment);
        // Update menu visibility logic
        this.showlogout = event.url.includes('/homepage');
        this.showHeader = !hiddenRoutes.includes(event.url);
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        this.userRole !== user.role ? this.userRole = user.role : null;
        if (user.role === 'REP_POB') {
          this.showPobDashboard = true;
          this.showKycDashboard = false;
          this.showHome = false;
        }
        else if (user.role === 'REP_KYC') {
          this.showPobDashboard = false
          this.showKycDashboard = false;
          this.showHome = false;
        }
        else {
          this.showKycDashboard = event.url.includes('/repkycdashboard');
          const pobPortalRoutes = ['hcpselection', 'hcpdetails', 'productlist', 'cart', 'cartdetails'];
          this.showPobDashboard = pobPortalRoutes.includes(lastSegment);
          const pobPortalRoutes1 = ['hcpselection', 'hcpdetails', 'productlist', 'cart', 'cartdetails'];
          this.showHome = pobPortalRoutes1.includes(lastSegment);
        }
      }
    });
  }

  currentPageTitle: string = '';
  // setPageTitle(): void {
  //   const currentPage = this.getCurrentPage(); // Assume this method returns the current page's name
  //   if (['repkycdashboard'].includes(currentPage)) {
  //     this.currentPageTitle = 'KYC Portal';
  //   } else if (['hcpselection', 'hcpdetails', 'productlist', 'cart', 'cartdetails'].includes(currentPage)) {
  //     this.currentPageTitle = 'POB Portal';
  //   } else {
  //     this.currentPageTitle = ''; // Or set a default title if needed
  //   }
  // }
  private routerSubscription: Subscription | undefined;
  currentPage: any
  getCurrentPage() {
    // return this._router.url.split('/')[2];  // Extracts the current page name from the URL
    this._router.events.subscribe(event => {
      this.currentPage = this._router.url.split('/').pop();
      if (event instanceof NavigationEnd) {
        this.setPageTitle(event.urlAfterRedirects); // Get the current URL after redirects
      }
    });
  }

  // Set the page title based on the current URL
  setPageTitle(url: string): void {
    // Check if the URL matches the conditions for each title
    if (url.includes('repkycdashboard')) {
      this.currentPageTitle = 'KYC Portal';
    } else if (url.includes('hcpselection') || url.includes('hcpdetails') || url.includes('productlist') || url.includes('cart') || url.includes('cartdetails') || url.includes('pobhome')) {
      this.currentPageTitle = 'POB Portal';
    } else {
      this.currentPageTitle = ''; // Optionally set a default title
    }
  }

  // Function to check if the current page is one of the specific pages
  isPOBPage(): boolean {
    const validPages = ['hcpselection', 'hcpdetails', 'productlist', 'cartdetails'];
    return validPages.includes(this.currentPage);
  }
  // // Function to check if the current page is 'repkycdashboard' for KYC role
  // isKYCPage(): boolean {
  //   return this.currentPage === 'repkycdashboard';
  // }
  // Helper function to capitalize the first letter
  capitalizeFirstLetter(text: string): string {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }
  Home() {
    this._router.navigate(['/homepage'])
  }
  Pobdashboard() {
    this._router.navigate(['/homepage/pobhome'])
  }
  hcpSelection() {
    this._router.navigate(['/homepage/hcpselection'])
  }

  Kycdashboard() {
    this._router.navigate(['/homepage/repkycdashboard'])

  }
  goBack() {
    let redirectpage = sessionStorage.getItem('PageRedirection')
    if (redirectpage === "Y") {
      if (this.Page === 'repkycdashboard') {
        this._router.navigate(['/homepage/repkycdashboard']).then(() => {
          // Clear the sessionStorage value
          sessionStorage.setItem('PageRedirection', "");
          // Optional: Reload the page (if needed)
          location.reload();
        });
      }
      else {
        this._router.navigate(['/UserKycDashboard']).then(() => {
          // Clear the sessionStorage value
          sessionStorage.setItem('PageRedirection', "");
          sessionStorage.setItem('hidebackbtn', "N")
          // Optional: Reload the page (if needed)
          location.reload();
        });
      }

    }
    else {
      this.location.back(); // Navigates to the previous page
    }
  }

  openModal() {
    const data: ModalData = {
      title: 'Confirm Logout',
      message: 'Are you sure you want to logout?',
      buttons: [
        { text: 'No, go back', value: 'cancel', cssClass: 'btn-cancel' },
        { text: 'Logout', value: 'logout', cssClass: 'btn-confirm' }
      ]
    };

    const dialogRef = this.dialog.open(PopupModalComponent, { data, backdropClass: 'backdrop', disableClose: true, });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Dialog result:', result);
      if (result === 'logout') {
        this._spinner.show();
        this.trackingService.trackEvent('KYC Logout-view', 'Logout Link_Click', '' + this.Name, 'Log Out Link click');
        // if (this._cookieService.get('Role') == 'STK') {
        //   var Api = "Admin/StkLogout";
        //   this._repo.getmethodWithHeaderParam(Api).subscribe((result: any) => {

        //     if (result.code == '401' || result.code == '805' || result.code == '400' || result.code == '824' || result.code == '825')  //805 wrong otp, 400- 4 digit otp req
        //     {
        //       this.toastService.showError(result.message);
        //     }
        //     else if (result.code == '401') // token expired
        //     {
        //       this.toastService.showError(result.message);
        //       this._spinner.hide();
        //       this.LogOutClear();
        //     }
        //     else if (result.code == '200') {
        //       this.toastService.showSuccess(result.message);
        //       this._spinner.hide();
        //       this.LogOutClear();
        //     }
        //     else {
        //       this.toastService.showError(Constants.msgSomethingWrong);
        //     }
        //   })
        // }
        // else {
        //   this.LogOutClear();
        // }
        this.LogOutClear();
        this._spinner.hide();
      }
    });
  }
}  
